var _g, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 133 134",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65,
    r: 47.5,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m87.818 43.539h-47.842c-2.5679 0-4.6495 2.0817-4.6495 4.6495v32.252c0 2.5678 2.0816 4.6495 4.6495 4.6495h47.842c2.5679 0 4.6495-2.0817 4.6495-4.6495v-32.252c0-2.5678-2.0816-4.6495-4.6495-4.6495z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m87.824 85.76h-47.849c-1.4096 0-2.7616-0.5595-3.759-1.5557-0.9974-0.9961-1.5587-2.3474-1.5605-3.7571v-32.259c0.0106-1.4076 0.5744-2.7545 1.5697-3.7498 0.9953-0.9954 2.3423-1.5592 3.7498-1.5697h47.849c1.4075 0.0105 2.7544 0.5743 3.7498 1.5697 0.9953 0.9953 1.5591 2.3422 1.5696 3.7498v32.259c-0.0017 1.4097-0.563 2.761-1.5604 3.7571-0.9974 0.9962-2.3494 1.5557-3.759 1.5557zm-47.849-41.538c-1.0522 0.0105-2.0583 0.4331-2.8024 1.1772-0.744 0.744-1.1667 1.7502-1.1771 2.8024v32.245c0.0122 1.051 0.4356 2.0555 1.1795 2.7981 0.7438 0.7426 1.749 1.1643 2.8 1.1748h47.849c1.051-0.0105 2.0562-0.4322 2.8-1.1748 0.7439-0.7426 1.1673-1.7471 1.1795-2.7981v-32.259c-0.0104-1.0522-0.4331-2.0584-1.1771-2.8024-0.7441-0.7441-1.7502-1.1667-2.8024-1.1772l-47.849 0.0134z",
    fill: "#00C65E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31.024 85.003h65.107c0.0675 0 0.1322 0.0268 0.18 0.0745 0.0477 0.0478 0.0745 0.1125 0.0745 0.1801v2.1304c0 0.3838-0.1524 0.7519-0.4238 1.0233s-0.6395 0.4238-1.0233 0.4238h-62.722c-0.3838 0-0.7519-0.1524-1.0233-0.4238s-0.4238-0.6395-0.4238-1.0233v-2.117c-0.0018-0.0346 0.0034-0.0691 0.0154-0.1016 0.012-0.0324 0.0304-0.0621 0.0542-0.0872 0.0239-0.0251 0.0526-0.045 0.0843-0.0586 0.0318-0.0137 0.0661-0.0207 0.1007-0.0206z",
    fill: "#1E7836"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.666,
    y: 47.166,
    width: 31.11,
    height: 10.372,
    rx: 1,
    fill: "#FFB762"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.666,
    y: 59.041,
    width: 31.11,
    height: 10.372,
    rx: 1,
    fill: "#FFB762"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.666,
    y: 71.091,
    width: 31.11,
    height: 10.372,
    rx: 1,
    fill: "#FFB762"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90 76.76 79.26)",
    x: 76.76,
    y: 79.26,
    width: 31.11,
    height: 10.372,
    rx: 1,
    fill: "#CCEFDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m90.661 92.095 6.2783-1.374-6.3585-1.389-1.5245-5.4308-1.5244 5.4308-6.3585 1.389 6.2733 1.374 1.6096 5.7217 1.6047-5.7217z",
    fill: "#FD9558"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m41.826 42.504 7.9175-1.7485-8.0156-1.7659-1.9274-6.9018-1.9217 6.9018-8.0213 1.7659 7.9175 1.7485 2.0255 7.2654 2.0255-7.2654z",
    fill: "#FD9558"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m30.486 78.903 2.432-0.6164-2.4655-0.623-0.5963-2.4253-0.5895 2.4253-2.4722 0.623 2.4387 0.6164 0.623 2.5593 0.6298-2.5593z",
    fill: "#00C65E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0.5,
    width: 133,
    height: 133,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 3,
    result: "effect1_dropShadow_5137_19965"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.211765 0 0 0 0 0.227451 0 0 0 0 0.270588 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5137_19965"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5137_19965",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.76b7409b28190b48c26ef106c9941157.svg";
export { ForwardRef as ReactComponent };